export default {"src":"/_next/static/media/undraw_events.220716fc.svg","height":176,"width":230,"blurWidth":0,"blurHeight":0};